import React from 'react';
import { Card } from '@repo/ui';
import { BulkCreationTab } from '../components';

export function TrustRequestCreationPage() {
  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div>
        <h1 className="text-3xl font-bold text-xtnd-dark dark:text-xtnd-white">Trust Request Creation</h1>
        <p className="text-xtnd-dark-600 dark:text-xtnd-light-400 mt-2">
          Create trust requests in bulk based on trust balance calculations.
        </p>
      </div>

      {/* Content */}
      <Card variant="outlined" padding="lg">
        <BulkCreationTab />
      </Card>
    </div>
  );
}

